import { Spin } from "antd";
import React, { FormEvent } from "react";
import { cn } from "utils";

export interface ButtonProps {
  onClick?: (e: FormEvent) => void;
  label: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  label,
  className = "",
  disabled = false,
  isLoading = false,
}) => {
  return (
    <button
      className={cn(
        "text-white p-3 flex items-center justify-center w-full font-bold rounded-md ease-in-out duration-300 bg-orange",
        {
          "cursor-not-allowed bg-brown opacity-50": disabled || isLoading,
        },
        className
      )}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? <Spin size="default" /> : label}
    </button>
  );
};

export default Button;
